export function createShelfStorageActionFacade(context = {}) {
  const {
    getShelfOrchestrator
  } = context;

  const getOrchestrator = () => (
    typeof getShelfOrchestrator === 'function'
      ? getShelfOrchestrator()
      : null
  );

  function loadCategories() {
    getOrchestrator()?.loadCategories?.();
  }

  function saveCategories() {
    getOrchestrator()?.saveCategories?.();
  }

  function loadCollections() {
    getOrchestrator()?.loadCollections?.();
  }

  function saveCollections() {
    getOrchestrator()?.saveCollections?.();
  }

  function loadBooklists() {
    getOrchestrator()?.loadBooklists?.();
  }

  function saveBooklists() {
    getOrchestrator()?.saveBooklists?.();
  }

  function loadGlobalShelfOrder() {
    getOrchestrator()?.loadGlobalShelfOrder?.();
  }

  function saveGlobalShelfOrder() {
    getOrchestrator()?.saveGlobalShelfOrder?.();
  }

  function updateGlobalShelfOrderForCollectionOrder(orderedCollectionIds) {
    getOrchestrator()?.updateGlobalShelfOrderForCollectionOrder?.(orderedCollectionIds);
  }

  function generateCollectionId() {
    return getOrchestrator()?.generateCollectionId?.();
  }

  function generateBooklistId() {
    return getOrchestrator()?.generateBooklistId?.();
  }

  function removeBooksFromAllCollections(bookIds) {
    return getOrchestrator()?.removeBooksFromAllCollections?.(bookIds);
  }

  function removeBooksFromAllBooklists(bookIds) {
    return getOrchestrator()?.removeBooksFromAllBooklists?.(bookIds);
  }

  function addBooksToCollection(collectionId, bookIds) {
    getOrchestrator()?.addBooksToCollection?.(collectionId, bookIds);
  }

  return {
    loadCategories,
    saveCategories,
    loadCollections,
    saveCollections,
    loadBooklists,
    saveBooklists,
    loadGlobalShelfOrder,
    saveGlobalShelfOrder,
    updateGlobalShelfOrderForCollectionOrder,
    generateCollectionId,
    generateBooklistId,
    removeBooksFromAllCollections,
    removeBooksFromAllBooklists,
    addBooksToCollection
  };
}
